// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.mat-mdc-table {
    table-layout: fixed;
}

.container {
    text-align: center;

    .inner-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        margin-top: 20%;

        .img {

            max-width: 300px;
            width: 300px; 
        }

        .title {
            font-size: 2rem;
            font-weight: bold;
            color: #000;
            margin-bottom: 1rem;
        }

        .description {
            font-size: 1rem;
            color: #000;
        }
    }
}


th,td{
    text-align: center !important;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/views/statistics/pending-reviews/pending-reviews.component.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;;IAElB;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;;QAEnB,eAAe;;QAEf;;YAEI,gBAAgB;YAChB,YAAY;QAChB;;QAEA;YACI,eAAe;YACf,iBAAiB;YACjB,WAAW;YACX,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,WAAW;QACf;IACJ;AACJ;;;AAGA;IACI,6BAA6B;IAC7B","sourcesContent":["\r\n.mat-mdc-table {\r\n    table-layout: fixed;\r\n}\r\n\r\n.container {\r\n    text-align: center;\r\n\r\n    .inner-content {\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        margin-top: 20%;\r\n\r\n        .img {\r\n\r\n            max-width: 300px;\r\n            width: 300px; \r\n        }\r\n\r\n        .title {\r\n            font-size: 2rem;\r\n            font-weight: bold;\r\n            color: #000;\r\n            margin-bottom: 1rem;\r\n        }\r\n\r\n        .description {\r\n            font-size: 1rem;\r\n            color: #000;\r\n        }\r\n    }\r\n}\r\n\r\n\r\nth,td{\r\n    text-align: center !important;\r\n    }\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
